import React from 'react'
import Categories from './categories'
import { withStore } from '../context/store.context'
import { withCategories } from '../context/categories.context'

const CategoriesContainer = ({ store, categories, className }) => {
  return (
    <Categories
      activeCategory={store.selectedCategory}
      categories={categories}
      className={className}
    />
  )
}

export default withCategories(withStore(CategoriesContainer))
